import { Route, RouteProps, Redirect } from "react-router";
export const AdminOnlyRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {

    let result = JSON.parse(localStorage.getItem("user"));
    console.log("ressss", result)
    return <Route
        {...rest}
        render={props =>
            result && result.isAdmin ? (
                <Layout>
                    <Component {...props} />
                </Layout>
            ) :
                (
                    <Redirect to={{
                        pathname: "/",
                    }} />
                )
        }
    />
}